import ReactPaginate from "react-paginate";
import { EllipsisHorizontalIcon, ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

export const Pagination = ({ currentPage, setCurrentPage, pageCount }) => {
    const handlePageClick = (e) => {
        setCurrentPage(e.selected);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const itemStyle = `flex items-center justify-center rounded-full font-semibold p-1.5
        text-gray-600 hover:bg-gray-300
        dark:text-gray-200 dark:hover:bg-zinc-700 dark:hover:text-white
        focus-within:outline-none active:scale-95 transition duration-150 ease-in-out`;

    return (
        <div className="flex items-center ml-auto mr-0">
            <ReactPaginate
                breakLabel={<EllipsisHorizontalIcon className="w-5 h-5" />}
                nextLabel={<ChevronRightIcon className="w-5 h-5" />}
                onPageChange={handlePageClick}
                pageRangeDisplayed={2} // 現在のページの前後に表示するページ数
                marginPagesDisplayed={1} // 先頭と末尾に表示するページ数
                pageCount={pageCount}
                previousLabel={<ChevronLeftIcon className="w-5 h-5" />}
                renderOnZeroPageCount={null}
                forcePage={currentPage}
                
                containerClassName="flex items-center gap-1 list-none text-sm"

                // Page number buttons
                pageClassName="block"
                pageLinkClassName={itemStyle + " px-3"}
                
                // Previous and Next buttons
                previousClassName="block"
                previousLinkClassName={itemStyle}
                nextClassName="block"
                nextLinkClassName={itemStyle}
                
                //  Current active page
                activeLinkClassName="text-white bg-indigo-600 hover:bg-indigo-700 dark:hover:!bg-indigo-700 rounded-full"
                
                breakClassName="block"
                breakLinkClassName="flex items-center justify-center text-slate-400"
                disabledLinkClassName="hidden"
            />
        </div>
    );
};